exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header[data-v-b7d891a2] {\n\tbackground-color: #F8F9FA;\n\tborder-bottom: 1px solid #ededed;\n\tpadding: 5px 10px;\n}\n.header__social[data-v-b7d891a2] {\n\ttext-align: left;\n\tmargin-top: auto;\n\tmargin-bottom: auto;\n}\n.header__contact[data-v-b7d891a2] {\n\ttext-align: right;\n}\na[data-v-b7d891a2] {\n\tcolor: #cf0614;\n}\n@media (max-width: 767px) {\n.header__social[data-v-b7d891a2] {\n\t\tfont-size: 16px;\n}\n}\n\n", ""]);

// exports
